import './style.less';

export default function($log) {
  'ngInject';

  const vm = this;
  vm.$onChanges = activate;

  function activate() {
    try {
      $log.debug('Activities Table Component Activated');
    } catch (e) {
      throw e;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/activities/activitiesTable/controller.js